import { Avatar, Box, Typography } from '@mui/material';
import { ethereumApi } from '@yozh-io/1inch-widget-api-client';
import React from 'react';

import { Token } from '../../../../store';
import { roundPercentInRoutes } from '../../../../utils';
import { NoLogoURI, RouteStepArrow } from '../../../icons';
import { NoRoutes } from '../NoRoutes';

interface OneInchRoutesProps {
  protocols: any;
  tokens: { [key: string]: Token };
  totalRouteSteps: number;
}

export const OneInchRoutes = ({ protocols, tokens, totalRouteSteps }: OneInchRoutesProps) => {
  const protocolLength = protocols?.length;
  return (
    <Box
      sx={{
        display: 'grid',
        gridAutoColumns: '1fr',
        gridAutoRows: 'auto',
        justifyItems: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        columnGap: '10px',
      }}>
      {protocolLength && totalRouteSteps ? (
        protocols.flatMap((path: any, pathIndex: number) => {
          const percent = (path.length * 100) / totalRouteSteps;
          return (
            <React.Fragment key={pathIndex}>
              <Box
                sx={{
                  gridColumn: `${pathIndex + 1}`,
                  gridRow: '1',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  rowGap: '6px',
                  padding: '15px 0',
                }}>
                {percent && protocolLength > 1 && (
                  <Typography variant="rsm14" color="widget.text-secondary">
                    {roundPercentInRoutes(percent, 2)} %
                  </Typography>
                )}
                <RouteStepArrow />
              </Box>
              {path.length &&
                path.flatMap((step: ethereumApi.PathViewDto[], stepIndex: number) => {
                  return (
                    <React.Fragment key={stepIndex}>
                      <Box
                        sx={{
                          gridColumn: `${pathIndex + 1}`,
                          gridRow: `${(stepIndex + 1) * 2}`,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            rowGap: '6px',
                            border: '1px solid',
                            borderColor: 'widget.border-03',
                            borderRadius: '12px',
                            padding: '5px',
                          }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '4px' }}>
                            <Avatar
                              src={tokens[step[0].toTokenAddress]?.logoURI}
                              alt={tokens[step[0].toTokenAddress]?.symbol}
                              sx={{ width: 24, height: 24, backgroundColor: 'transparent' }}>
                              <NoLogoURI />
                            </Avatar>
                            <Typography variant="mm16" color="widget.text-primary">
                              {tokens[step[0].toTokenAddress]?.symbol}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              rowGap: '4px',
                            }}>
                            {step.map((prot: ethereumApi.PathViewDto, protIndex: number) => {
                              return (
                                <Box
                                  key={protIndex}
                                  sx={{
                                    borderRadius: '8px',
                                    minWidth: '118px',
                                    padding: '0 5px',
                                    backgroundColor: 'widget.bg-01',
                                  }}>
                                  <Typography
                                    variant="rxs12"
                                    color="widget.text-secondary">{`${prot.name} ${prot.part}%`}</Typography>
                                </Box>
                              );
                            })}
                          </Box>
                        </Box>
                      </Box>
                      <Box sx={{ gridColumn: `${pathIndex + 1}`, gridRow: `${stepIndex * 2 + 3}`, padding: '15px 0' }}>
                        <RouteStepArrow />
                      </Box>
                    </React.Fragment>
                  );
                })}
            </React.Fragment>
          );
        })
      ) : (
        <NoRoutes />
      )}
    </Box>
  );
};
